// Angular
import { NgModule } from '@angular/core';
import { HotelCurrencyService } from './hotel-currency.service';

// Afidium

@NgModule({
    providers: [HotelCurrencyService]
})
export class HotelCurrencyModule {
}